import { createRoot } from 'react-dom/client';
import SiteApp from './SiteApp';

const el = document.getElementById('root');
if (!el) throw new Error('#root bulunamadı');

createRoot(el).render(<SiteApp />);
